<template>

    <v-container>
        <btn-a class="ma-2" outlined rounded color="primary" @click="dialogOpen = true">
            <v-icon>mdi-plus</v-icon>
        </btn-a>

        <div class="d-flex w-100 mt-5">

            <!-- <div class="w-100 mr-5" style="flex: 1;">
                <p>Variável</p>
                <v-list>
                    <div v-for="(item, i) in variablesResource" :key="i">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.field"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action @click="openEdit(item)">
                                <v-btn icon>
                                    <v-icon color="warning">mdi-pencil</v-icon>
                                </v-btn>
                            </v-list-item-action>
                            <v-list-item-action>
                                <v-btn icon @click="removeVariable(i)">
                                    <v-icon color="error">mdi-delete</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>
                    </div>
                </v-list>
            </div>

            <div class="w-100 flex-1" style="flex: 1;">
                <p>Variável Interna</p>
                <v-list class="w-100">
                    <div v-for="(item, i) in variableInternal" :key="i">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.variableKey"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                    </div>
                </v-list>
            </div> -->



        </div>

        <v-data-table :key="key" ref="table" :headers="headers" :items="variablesResource"
        class="elevation-1" hide-default-footer :loading="false">
    
        <template v-slot:[`item.actions`]="{ item, index }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item link @click="openEdit(item)">
              <v-list-item-icon>
                <v-icon color="secondary" v-text="'mdi-pencil'"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="'Editar'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item link @click="removeVariable(item, index)">
              <v-list-item-icon>
                <v-icon
                  color="secondary"
                  v-text="'mdi-trash-can-outline'"
                ></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="'Delete'"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
        </v-data-table>

        <dialog-d v-model="dialogOpen" @confirm="addVariable" @cancel="dialogOpen = false"
            :title="'Adicionar Variavel'">
            <resource-variable-dialog :item="variable" :isOpen="dialogOpen" @value="handleValues">
            </resource-variable-dialog>
        </dialog-d>

    </v-container>

</template>

<script>
import resourceService from "@/services/regTypeService";
import resourceVariableDialog from "./resourceVariableDialog.vue"
export default {
    props: ["stageTypes", "variables"],
    name: "variable-table",
    data(){
        return {
            key: 0,
            variableInternal: [],
            dialogOpen: false,
            variablesResource: this.variables || [],
            variable: null,
            headers: [
                { text: 'Variável', value: 'variableKey', sortable: false },
                { text: 'Variável Interna', value: 'variableInternal', sortable: false, },
                {
                    text: "", align: "end", sortable: false,
                    value: "actions"
                }
            ]
        }
    },
    components: {
       resourceVariableDialog
    },
    watch: {
        variables(item){
            console.log("variables >>> ", item)
            this.variablesResource = item
        },
        async stageTypes(value){

            console.log("VALUES >>> ", value)

            let regsTypes = []
            if(value.regTypeIds.length > 0){
                for(let i = 0; i < value.regTypeIds.length; i++){
                    let res = await resourceService.getById(value.regTypeIds[i])
                    regsTypes.push(res.data)
                }
            }

            this.variableInternal = []
                regsTypes.map((item) => {
                    item.regTypeFields.map((regType) => {
                        if(regType.typeData == 4){
                            this.variableInternal.push(regType)
                        }
                    })
                })
        },

        dialogOpen(value){
            if(!value){
                this.variable = null
            }
            this.key += 1
        }
    },
    mounted(){
    },

    methods: {
        handleValues(e){
            this.variable = e
            console.log("E >>> ", this.variable)
        },

        addVariable(){

            let index
            index = this.variablesResource.findIndex(item => item.code == this.variable.code)

            
            if(index != -1){
                this.variablesResource[index] = this.variable
            } else {
                console.log("AQUI >>> ", this.variable)
                this.variablesResource.push(this.variable)
            }

            this.variable = null
            this.dialogOpen = false

            this.key += 1
            this.$emit("variables", this.variablesResource)
        },

        removeVariable(index){
            this.variablesResource.pop(index)
        },

        openEdit(item){
            this.dialogOpen = true
            this.variable = item
        }
    }
}
</script>

<style>

</style>